import {useCallback} from "react";
import {useIntl} from "react-intl";

import {Brand} from "utils/brand";
import {type TranslationKey} from "i18n/translations";

// Workspace-local copy of the monolith's useI18n: it imports react + react-intl, so it
// can't be aliased across the react@16/19 boundary (see migration-plan "What cannot be
// shared"). The branded-key fallback logic mirrors the monolith. PrimitiveType is inlined
// to avoid pulling intl-messageformat in directly.
type PrimitiveType = string | number | boolean | null | undefined | Date;

export function useI18n() {
    const intl = useIntl();

    return useCallback(
        (id: TranslationKey, context?: {values?: Record<string, PrimitiveType>; brand?: Brand}): string => {
            if (context?.brand && context.brand !== Brand.DEFAULT_BRAND) {
                const brandedKey = `${id}__${context.brand}`;
                if (intl.messages[brandedKey]) {
                    return intl.formatMessage({id: brandedKey, defaultMessage: id}, context?.values);
                }
            }
            return intl.formatMessage({id, defaultMessage: id}, context?.values);
        },
        [intl],
    );
}
